// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3ifMp","imageUploader":"EGiftCard_imageUploader__1OGrr"};